import React from "react";
import logo from "../images/familee_tree_logo.svg";
import { useFormik } from 'formik';
import { userLogin } from "../services/ApiServices";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
 
const validate = values => {
  const errors = {};
  if (!values.emailId) {
    errors.emailId = 'Please enter your email-ID.';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailId)) {
    errors.emailId = 'Please enter a valid email address.';
  } else if (!values.password) {
    errors.password = 'Please enter your password.';
  }
  return errors;
};
const Login = () => {
      const formik = useFormik({
        initialValues: { emailId: '', password: ''},
        validate,
        onSubmit: async (values, { setSubmitting }) => {
          try {
              const userInfo = await userLogin(values);
              if( userInfo.status === 200) {
                const { token, role, profileImage, emailId, mobileNumber } = userInfo?.data?.data
                window.localStorage.setItem('isLoggedIn', 'true');
                window.localStorage.setItem('userType', role);
                window.localStorage.setItem('token', token);
                const userData =  { profileImage : profileImage, emailId: emailId, mobileNumber: mobileNumber}
                window.localStorage.setItem('users', JSON.stringify(userData));
  
                if (role === 'superAdmin') {
                  window.location.href = "/";
                  toast.success("Login Successfully")
              } else {
                toast.error('Access denied. Please contact administrator.')
              }
              } 
          } catch (error) {
              toast.error(error.response.data.message)
          } finally {
              setSubmitting(false);
          }
      }
    })      
      return  (
        <React.Fragment>
          <div className="login-page">
            <div className="login-container">
              <img src={logo} alt="FamileeTree" className="logo" />
              <form className="login-form" onSubmit={formik.handleSubmit}>
                <div className="input-group">
                  <label htmlFor="emailId">Email Address:</label>
                  <input 
                  type="text" 
                  id="emailId" 
                  name="emailId" 
                  value={formik.values.emailId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  />
                </div>
                {formik.touched.emailId && formik.errors.emailId ? <p className="error-message">{formik.errors.emailId}</p> : null}
                <div className="input-group">
                  <label htmlFor="password">Password:</label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                {formik.touched.password && formik.errors.password ? <p className="error-message">{formik.errors.password}</p> : null}
                <button type="submit">Login</button>
              </form>
              <div className="login-forget">
              <Link to='/ForgotPasswordEmailId'>Forget Password?</Link>
              </div>
             
            </div>
          </div>
        </React.Fragment>
      )



};
export default Login;
